import _ from "underscore";
function flattenHelper(list) {
  return _.flatten(list);
}

export default flattenHelper;
